import { FunctionComponent } from 'react'
import useRefundDetailsModal from './RefundDetailsModal.hook'
import useStyles from './RefundDetailsModal.styles'
import { Modal, Text, getTheme } from '@conexasaude/conexa-hero'

const RefundDetailsModal: FunctionComponent = () => {
  const styles = useStyles()
  const theme = getTheme()
  const { modalOpen, closeModal, refundDetailsList } = useRefundDetailsModal()
  return (
    <Modal
      title="Detalhes do estorno"
      opened={Boolean(modalOpen)}
      primaryActionLabel="Fechar"
      primaryAction={closeModal}
      negativeAction={closeModal}
      onClose={closeModal}
      size={600}
    >
      <div css={styles.container}>
        <Text renderAs="span">Valor a ser estornado: </Text>
        <Text renderAs="span" color={theme.colors.brand.primary[300]}>
          {refundDetailsList?.amountPaid}
        </Text>
        <div>
          <Text renderAs="span">Cartão a ser estornado: </Text>
          <Text renderAs="span">
            Final {refundDetailsList?.endCard} - {refundDetailsList?.flagCard}{' '}
          </Text>
        </div>
        <div css={styles.boxContainer}>
          <div>
            <Text>Responsável</Text>
            <Text renderAs="p" variant="paragraphSmall">
              {refundDetailsList?.refundUsername}
            </Text>
          </div>
          <div>
            <Text>Data e hora</Text>
            <Text renderAs="p" variant="paragraphSmall">
              {refundDetailsList?.refundDate}
            </Text>
          </div>
          <div>
            <Text>Motivo</Text>
            <Text renderAs="p" variant="paragraphSmall">
              {refundDetailsList?.refundReason}
            </Text>
          </div>
        </div>
        <div css={styles.containerDetails}>
          <Text>Detalhes</Text>
          <Text renderAs="p" variant="paragraphSmall">
            {refundDetailsList?.refundDetails}
          </Text>
        </div>
      </div>
    </Modal>
  )
}

export default RefundDetailsModal
